import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DocumentStatus } from '@icc/b2b/shared';

@Component({
    selector: 'icc-complaint-status',
    templateUrl: './complaint-status.component.html',
    styleUrls: ['./complaint-status.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ComplaintStatusComponent {
    @Input() status: DocumentStatus;
}
